import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginForm from "./Components/LoginForm/LoginForm";
import HomePage from "./Components/HomePage/HomePage"; // Ensure HomePage exists

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginForm />} />
      <Route path="/homepage" element={<HomePage />} />
    </Routes>
  );
}

export default App;
